var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setTime"},[_c('slider-bar',{attrs:{"value":_vm.time,"min:":_vm.min,"max":_vm.max,"dotSize":30,"color":"#000","formatter":_vm.formatter},on:{"change":_vm.changeTimeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }